import { Cancel } from 'iconoir-react'
import React, { useState, useEffect } from 'react'
import Button from '../Button'
import DropDown from '../dropdowns/Dropdown'
import InputField from '../InputField'
import { useDispatch, useSelector } from 'react-redux'
import { getUsers } from '../../../redux_store/users/users_thunk'

const CreateNotificationModal = ({onSubmit, onCancel}) => {
  const dispatch = useDispatch();
  const [showUsersDropDown, setShowUsersDropDown] = useState({list: false, textField: false});  
  const [selectedUser, setSelectedUser] = useState({label: '', user: {}});
  const [addedUsers, setAddedUsers] = useState([])
  const { users } = useSelector((state)=>state.user);
  const [details, setDetails] = useState({});

  useEffect(() => {
    dispatch(getUsers('all'));
    // eslint-disable-next-line
  }, [])  

  const onInputChange = (e) => {
    const { name, value } = e.target;
    setDetails({...details, [name]:value});
  }

  return (
    <form onSubmit={(e)=>onSubmit(e, {...details, user: selectedUser.user})} className="fixed z-20 inset-0 overflow-y-auto">
      <div className="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
        <div className="fixed inset-0 transition-opacity">
          <div className="absolute inset-0 bg-gray-900 bg-opacity-75"></div>
        </div>
        <span className="hidden sm:inline-block sm:align-middle sm:h-screen"></span>&#8203;
        <div className="inline-block p-5 align-bottom w-2/6 rounded-lg bg-white text-left overflow-hidden shadow-xl transform transition-all sm:my-12 sm:align-middle" role="dialog" aria-modal="true" aria-labelledby="modal-headline">
          <label className='flex justify-between mb-5'>
            <h1 className='text-lg wayrideColor font-bold'>Create Notification</h1>
            <Cancel onClick={onCancel} className='cursor-pointer bg-gray-300 rounded-full text-gray-900 h-7 w-7 p-1' />
          </label>
          <p className='text-gray-500 font-medium text-sm'>
            Broadcast this message to
          </p>
          <DropDown 
            selected={details.to}
            onSelect={(val)=>{
              if(val === 'Specific User'){
                setShowUsersDropDown({list: true, textField: true});
              }else{
                setShowUsersDropDown({list: false, textField: false});
              }
              setDetails({...details, to: val})
            }}
            items={['All App Users', 'All Drivers', 'All Customers', 'Specific User']} 
            defaultSelect="Select Group" 
          />          
          {(showUsersDropDown.list || showUsersDropDown.textField) && 
          <>
            <br />          
            <br />
            <InputField
              value={selectedUser.label} 
              size="small"
              type={'text'}            
              placeholder={'Search for specific user by name or email'}
              onChange={(e)=>{
                const {value} = e.target;
                setShowUsersDropDown({list: true})
                const searchedUser = users.filter((user)=>
                  user.surname.toLowerCase().includes(value.toLowerCase()) ||
                  user.other_names.toLowerCase().includes(value.toLowerCase()) ||
                  user.email.toLowerCase().includes(value.toLowerCase())
                );
                setSelectedUser(value);
                setAddedUsers(searchedUser);
              }}
            />
            {showUsersDropDown.list &&
              <div style={{ width: '92%' }} className='border-gray-300 bg-white absolute cursor-pointer z-50 shadow-md shadow-slate-400 rounded'>
                {addedUsers && addedUsers.map((user)=>
                  <section onClick={()=>{
                    setSelectedUser({label: user.surname, user});
                    setShowUsersDropDown({list: false, textField: true});
                  }} className='my-1 border-t hover:bg-gray-50 py-1 px-2' value={`${user.surname} ${user.othername ? user.othername : ''}`}>
                    <p className='text-sm text-blue-600'>{user.surname} {user.othername}</p>
                    <p className='text-xs text-gray-500'>{user.email}</p>
                  </section>
                )}
              </div>
            }
          </>
          }
          <p className='text-gray-500 mt-5 font-medium text-sm'>
            Communication Channel
          </p>
          <DropDown 
            selected={details.channel}
            onSelect={(val)=>{
              setDetails({...details, channel: val})
            }}
            items={['App Notification', 'Email Notification', 'SMS Notification']} 
            defaultSelect="Select Channel"
          />
          {/* <label className="block mt-5 col-span-3 text-sm">
            <span className="text-gray-500 dark:text-gray-400">Notification title</span>
            <InputField 
              type={'text'}
              name="notification_title"
              isRequired={true}
              onChange={onInputChange}
              size="small"
              value={details.notification_title}
              placeholder="Enter notification title" 
            />
          </label> */}
          <label className="block mb-5 mt-5 col-span-3 text-sm">
            <span className="text-gray-500 dark:text-gray-400">Notification message</span>
            <textarea
              rows="5"
              required
              className="block w-full border px-3 text-gray-600 py-2 rounded mt-1 text-sm border-gray-400 dark:bg-gray-700 focus:outline-none focus:shadow-outline-purple dark:text-gray-300 dark:focus:shadow-outline-gray form-input"
              placeholder="Notification message"
              name="notification_message"
              value={details.notification_message}
              onChange={onInputChange}
            />
          </label>
          <Button
            type="submit"
            label={'Send'}
            width="w-full"
            bgColor={'wayrideBgColor'}
          />
        </div>
      </div>
    </form>
  )
}

export default CreateNotificationModal